import { SEO } from "@/components/SEO";
import { Hero } from "@/components/Hero";
import { ClientLogos } from "@/components/ClientLogos";
import { Cases } from "@/components/Cases";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { CTASection } from "@/components/CTASection";
import { FAQS } from "@/lib/faqs";

export default function Home() {
  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "LD Media",
    url: "https://ldmedia.dk",
    logo: "https://customer-assets.emergentagent.com/job_5e88ad15-a14f-4eb7-a874-cac507979086/artifacts/haj2wfbo_1000000444.jpg",
    description:
      "LD Media er et dansk marketing bureau der hjælper virksomheder med organic marketing, Meta Ads, Google Ads, TikTok Ads, hjemmesider, SEO og content creation.",
    email: "ldmediaa1@gmail.com",
    telephone: "+45 91 64 92 29",
    founder: { "@type": "Person", name: "Abbas Khan" },
    foundingDate: "2025",
    address: { "@type": "PostalAddress", addressCountry: "DK" },
    sameAs: ["https://calendly.com/ldmediaa1/30min"],
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <SEO
        path="/"
        description="LD Media – dansk marketing bureau med fokus på organic marketing, Meta Ads, Google Ads, TikTok Ads, hjemmesider, SEO og content creation. Vi gør dit brand umulig at ignorere."
        jsonLd={[orgJsonLd, faqJsonLd]}
      />
      <Hero />
      <ClientLogos />
      <Cases limit={3} />
      <Services limit={6} />
      <Process />
      <Testimonials />
      <FAQ />
      <CTASection />
    </>
  );
}
